var ChartsPlugin = require('utils/charts/charts_plugin');
var Misc = require('utils/misc');

var ChartsAxis = ChartsPlugin.extend({
    divs: {},
    class: 'js-chart-buttons',
    buttonTemplate: require('utils/templates/chart_axis_buttons'),
    initPlugin: function () {
        var self = this;
        this.chartView.on('charts:draw:after', function () {
            self.foreachCharts(function (key, value) {
                this.onDrawCallback(key, value);
            });
        });
    },

    onDrawCallback: function (key, value) {
        var graphDiv = value.graphDiv;
        var $graphDiv = $(graphDiv);

        if (
            (this.divs[key] === undefined || $graphDiv.find('.' + this.class).length == 0) &&
            this.isMultipleAxes(key, value)
        ) {
            var self = this;
            var d = document.createElement(key);
            var $d = $(d);
            $d.html(this.buttonTemplate({ key: key }));
            $graphDiv.append(d);

            $d.css('position', 'absolute');
            $d.css('top', 'absolute');
            $d.addClass(this.class);

            this.divs[key] = d;

            $(value.graphDiv)
                .find('.js-chart-axis')
                .on('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    self.onBtnAxisChange(e.currentTarget);
                });
        }
        this.updateTop(key, value);
    },

    updateTop: function (key, chart) {
        var graphDiv = chart.graphDiv;
        var $graphDiv = $(graphDiv);
        var $d = $(this.divs[key]);
        var topObj = $graphDiv.find('.dygraph-rangesel-bgcanvas');
        var t = parseInt(topObj.css('top'));
        $d.css('top', '' + t + 'px');
    },

    isMultipleAxes: function (key, chart) {
        var axes = Misc.selectWhere(chart.user_attrs_.seriesInfo, undefined, 'actualAxis', true);
        return axes.length > 1;
    },

    onBtnAxisChange: function (e) {
        var stepDirection = $(e).attr('data-step');
        var chartKey = $(e).attr('data-chart');

        this.chartView.switchAxis(chartKey, parseInt(stepDirection));
        var currentDateWindow = this.getDateWindow();
        this.chartView.updateOptions(currentDateWindow[0], currentDateWindow[1], true, true);
    },
});

// getPrettyAxisLabels equally divides the interval [min, max] in subIntervals,
// such that the increment is one of 1x10^y, 2x10^y, 5x10^y.
function getPrettyAxisLabels(min, max, maxLabelCount, positionFunction, formatValue, tickDensity) {
    // positionFunction returns the position of the value on the axis.
    // This depends on the size of the axis and therefore should be defined
    // This example is ment as documentation. It returns the position 0 for min and 100 for max.
    positionFunction =
        positionFunction ||
        function (val, min, max) {
            return (100 * (val - min)) / (max - min);
        };
    formatValue =
        formatValue ||
        function (x) {
            return x;
        };
    tickDensity = tickDensity || 0;

    var minIncrement = (max - min) / maxLabelCount;
    var step = 1;

    // get the magnitude of the increment in powers of 10
    var log = Math.log10(minIncrement);
    var power10 = Math.floor(log);

    // get the closest "pretty" increment larger or equal then the minIncrement
    var remainder = log - Math.floor(log);
    if (remainder > Math.log10(5)) {
        power10 += 1;
    } else if (remainder > Math.log10(2)) {
        step = 5;
    } else if (remainder > Math.log10(1)) {
        step = 2;
    }

    var pow = Math.pow(10, power10);

    // adjust tick density
    // example:
    //  * min=-25,
    //  * max=155
    //  * current ticks: [-20 0, 20,40,60, 80, 100, 120, 140]
    // tickDensity = 1:  [-20 -10, 0, ... , 130, 140, 150]
    // tickDensity = 2:  [-20, -15, -10, .... , 130, 135, 140]
    // tickDensity = -1:  [0, 50, 100, 150]
    // tickDensity = -2:  [0, 100]
    //
    // Min and Max may vary as they are chosen the clossest possible to the given min max
    if (tickDensity != 0) {
        var stepSizes = [1, 2, 5];
        var currentStep = stepSizes.indexOf(step);
        var power10 = power10 + Math.floor((currentStep - tickDensity) / 3);
        pow = Math.pow(10, power10);
        var currentStep = (currentStep - tickDensity) % 3;
        if (Math.sign(currentStep) < 0) {
            currentStep += 3;
        }

        step = stepSizes[currentStep];
    }

    // omit scientific notation for powers between -1 and 2
    if (power10 >= -1 && power10 <= 2) {
        step *= pow;
        power10 = 0;
        pow = 1;
    }

    // get the smallest increment greater than min
    var currentValue = (min + ((step * pow - (min % (step * pow))) % (step * pow))) / pow;

    // initialize value array
    var labels = [
        {
            value: formatValue(currentValue),
            position: positionFunction(currentValue * pow, min, max),
        },
    ];

    // stop increment before we exceed max
    while (currentValue + step <= max / pow) {
        currentValue += step;
        labels.push({
            value: formatValue(currentValue),
            position: positionFunction(currentValue * pow, min, max),
        });
    }

    return { labels: labels, power: power10, showPower: power10 != 1, showBase: power10 != 0 };
}

module.exports = {
    ChartsAxis: ChartsAxis,
    getPrettyAxisLabels: getPrettyAxisLabels,
};
